import React from "react";

import { loadModules } from "@esri/react-arcgis";
const options = { url: "https://js.arcgis.com/3.29/" };
const app = {};
const urlProv =
  "https://pifa.oefa.gob.pe/arcgis/rest/services/PORTAL/LIMITES_FISCALIZABLES_OEFA/MapServer/2";
const urlDist =
  "https://pifa.oefa.gob.pe/arcgis/rest/services/PORTAL/LIMITES_FISCALIZABLES_OEFA/MapServer/3";

class MapComponent extends React.Component { 
  constructor(props) {
    super(props);
    let me=this;
    loadModules(
      [
        "esri/map",
        "esri/graphic",
        "esri/tasks/query",
        "esri/layers/ArcGISDynamicMapServiceLayer",
        "esri/layers/FeatureLayer",
        "esri/symbols/SimpleFillSymbol",
        "esri/symbols/SimpleLineSymbol",
        "esri/renderers/SimpleRenderer",
        "esri/Color",
        "esri/geometry/webMercatorUtils",
        "esri/geometry/Point"
      ],
      options
    ).then(
      ([
        Map,
        Graphic,
        Query,
        DynamicLayer,
        FeatureLayer,
        SimpleFillSymbol,
        SimpleLineSymbol,
        SimpleRenderer,
        Color,
        webMercatorUtils,
        Point
      ]) => {
        var highlightSymbol = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([189, 191, 192]),
            1.2
          ),
          new Color([125, 125, 125, 0.25])
        );
        var symbol = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([121, "085", "061", 0.25]),
            1
          ),
          new Color([125, 125, 125, 0])
        );
        var sfs = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([52, 148, 232]),
            2
          ),
          new Color([52, 148, 232, 0.25])
        );
        var SelectSymbol = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([255, 0, 0]),
            1.2
          ),
          new Color([125, 125, 125, 0.0])
        );
        app.map = new Map("viewDiv", {
          basemap: "topo",
          zoom: 5,
          minZoom: 3,
          maxZoom: 19,
          center: [-75.074387, -10.39665],
          showLabels: true
        });
        app.map.on("load", function() {
          app.map.graphics.enableMouseEvents();
          app.map.graphics.on("mouse-out", function(evt) {
            app.map.graphics.clear();
          });
          app.capaBase = new DynamicLayer(
            "https://pifa.oefa.gob.pe/arcgis/rest/services/PORTAL/LIMITES_FISCALIZABLES_OEFA/MapServer",
            {
              id: "red",
              opacity: 0.2,
              showAttribution: false
            }
          );
          app.map.addLayer(app.capaBase);
          app.capaDpto = new FeatureLayer(
            "https://pifa.oefa.gob.pe/arcgis/rest/services/PORTAL/LIMITES_FISCALIZABLES_OEFA/MapServer/0",
            {
              id: "Dpto",
              mode: FeatureLayer.MODE_AUTO,
              showAttribution: false,
              outFields: ["*"]
            }
          );
          app.capaProv = new FeatureLayer(urlProv, {
            id: "prov",
            mode: FeatureLayer.MODE_AUTO,
            showAttribution: false,
            opacity: 0.2,
            outFields: ["*"]
          });
          app.capaDist = new FeatureLayer(urlDist, {
            id: "dist",
            mode: FeatureLayer.MODE_AUTO,
            showAttribution: false,
            opacity: 0.2,
            outFields: ["*"]
          });
          app.capaDpto.setRenderer(new SimpleRenderer(symbol));
          app.capaDpto.setSelectionSymbol(sfs);

          app.map.addLayer(app.capaDpto);

          //Cargamos la Capa de Provincias
          app.lyrProv = new FeatureLayer(urlProv, {
            id: "Prov",
            mode: FeatureLayer.MODE_AUTO,
            outFields: ["*"]
          });
          app.lyrProv.hide();
          app.lyrProv.setRenderer(new SimpleRenderer(symbol));
          app.lyrProv.setSelectionSymbol(SelectSymbol);
          app.map.addLayer(app.lyrProv);

          //Cargamos la Capa de Distritos
          app.lyrDist = new FeatureLayer(urlDist, {
            id: "Dist",
            mode: FeatureLayer.MODE_AUTO,
            outFields: ["*"]
          });
          app.lyrDist.hide();
          app.lyrDist.setRenderer(new SimpleRenderer(symbol));
          app.lyrDist.setSelectionSymbol(SelectSymbol);
          app.map.addLayer(app.lyrDist);

          app.capaDpto.on("mouse-over", function(e) {
            get_graphic_mouse_over(e, "1");
          });
          app.lyrProv.on("mouse-over", function(e) {
            get_graphic_mouse_over(e, "2");
          });
          app.lyrDist.on("mouse-over", function(e) {
            get_graphic_mouse_over(e, "3");
          });
          //--Efecto cuando se hace clic en la capa visible
          app.nivel = "0";
          app.map.graphics.on("click", function(e) {
            app.nivel = e.graphic.attributes.id_att;
            if (app.nivel === "1") {
              app.codigo = e.graphic.attributes.IDDPTO;
            } else if (app.nivel === "2") {
              app.codigo = e.graphic.attributes.IDPROV;
            } else if (app.nivel === "3") {
              app.codigo = e.graphic.attributes.IDDIST;
            }
            /**CCamp**/
            //--Invocamos el Nivel de Seleccion
            set_zoom_nivel(app.nivel, app.codigo);
          });

          function get_graphic_mouse_over(e, idlyr) {
            e.graphic.attributes["id_att"] = idlyr;
            var highlightGraphic = new Graphic(
              e.graphic.geometry,
              highlightSymbol,
              e.graphic.attributes
            );
            app.map.graphics.add(highlightGraphic);
          }
          function set_zoom_nivel(nivel, codigo) {
            me.props.onSelectMap(codigo);
          }
        });
      }
    );
  }
  renderMap() {
    return;
  }
  render() {
    return <div>{this.renderMap()}</div>;
  }
}
export default MapComponent;
